<template>
  <v-dialog scrollable v-model="dialog" width="800px">
    <v-card tile>
      <vue-card-title
        :title="
          `View Details of ${logInfo.client_name ? logInfo.client_name : ''}`
        "
        :subtitle="
          `View Details of ${logInfo.client_name ? logInfo.client_name : ''}`
        "
        :icon="$getIcon('mdiEye')"
        closable
        @close="$emit('update:logInfo', null)"
      >
      </vue-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-4 pl-0 scrollbar-md">
        <div v-if="!isGeneralLog" class="pl-4">
          <div class="grey-text">
            <span>
              <v-icon v-text="$getIcon('mdiInformationOutline')"></v-icon>
            </span>
            <span class="ml-3 caption">Product Name:</span>
          </div>
          <div class="font-weight-bold ml-9">
            {{
              $getProp(
                logInfo,
                "sub_stage_logs.0.sales_achievements.0.service.name"
              )
            }}
          </div>
        </div>
        <div>
          <v-timeline align-top dense class="pt-0 mt-4">
            <v-timeline-item
              v-for="(log, i) in logs"
              :key="i"
              :icon="$getIcon('mdiFlash')"
              :color="colorMapper[log.communicationlog.priority] || 'grey'"
              small
            >
              <v-row align="center" justify="center" no-gutters>
                <v-col cols="12" md="4">
                  <v-row>
                    <v-col cols="1">
                      <div class="grey-text">
                        <v-icon
                          v-text="$getIcon('mdiCalendarMonthOutline')"
                          small
                        ></v-icon>
                      </div>
                    </v-col>
                    <v-col cols="10" class="caption">
                      <div>Date:</div>
                      <div class="pt-1">
                        <div class="font-weight-bold">
                          {{ $dayjs(log.created_at).format("YYYY-MM-DD") }}
                        </div>
                        <div>
                          {{ $dayjs(log.created_at).format("hh:mmA") }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4 pt-0 pl-0">
                  <v-row v-if="!isGeneralLog">
                    <v-col cols="1">
                      <div class="grey-text">
                        <v-icon
                          v-text="$getIcon('mdiInformationOutline')"
                          small
                        ></v-icon>
                      </div>
                    </v-col>
                    <v-col cols="10" class="caption">
                      <div>Current Stage:</div>
                      <div class="pt-1">
                        <div class="font-weight-bold">
                          {{ $getProp(log, "sub_stage_logs.0.sales_stage") }}
                        </div>
                        <div>
                          {{ $getProp(log, "sub_stage_logs.0.sub_stage_name") }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="3">
                  <v-row v-if="!isGeneralLog">
                    <v-col cols="1">
                      <div class="grey-text">
                        <v-icon
                          v-text="$getIcon('mdiInformationOutline')"
                          small
                        ></v-icon>
                      </div>
                    </v-col>
                    <v-col cols="10" class="caption">
                      <div>Price:</div>
                      <div class="pt-1">
                        <div class="font-weight-bold">
                          NRs.
                          {{
                            getCurrency(
                              $getProp(
                                log,
                                "sub_stage_logs.0.sales_achievements.0.price"
                              ) || 0
                            )
                          }}
                        </div>
                        <div>
                          Quantity:
                          {{
                            $getProp(
                              log,
                              "sub_stage_logs.0.sales_achievements.0.quantity"
                            )
                          }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="1">
                  <template v-if="logs.length > 1">
                    <v-icon
                      v-if="showDetails.includes(i)"
                      @click="
                        showDetails = showDetails.filter(each => each !== i)
                      "
                      v-text="$getIcon('mdiMinusCircleOutline')"
                      class="pointer"
                    ></v-icon>
                    <v-icon
                      v-else
                      @click="showDetails.push(i)"
                      v-text="$getIcon('mdiPlusCircleOutline')"
                      class="pointer"
                    ></v-icon>
                  </template>
                </v-col>
              </v-row>
              <v-row
                v-show="showDetails.includes(i)"
                justify="center"
                no-gutters
              >
                <v-col md="4" cols="12">
                  <v-row>
                    <v-col cols="1">
                      <div class="grey-text">
                        <v-icon v-text="$getIcon('mdiPhone')" small></v-icon>
                      </div>
                    </v-col>
                    <v-col cols="10" class="caption">
                      <div>Communication Medium:</div>
                      <div class="pt-1">
                        <span class="font-weight-bold">
                          {{ $getProp(log, "communicationlog.medium.name") }}
                        </span>
                        <span>
                          ({{
                            $getProp(log, "communicationlog.medium_direction")
                          }})
                        </span>
                      </div>
                      <div>
                        <span class="font-weight-bold">
                          {{ $getProp(log, "communicationlog.contact_label") }}
                        </span>
                        <span>
                          ({{ $getProp(log, "communicationlog.contact") }})
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col md="4" cols="12">
                  <v-row>
                    <v-col cols="1">
                      <div class="grey-text">
                        <v-icon
                          v-text="$getIcon('mdiAccountTie')"
                          small
                        ></v-icon>
                      </div>
                    </v-col>
                    <v-col cols="10" class="caption">
                      <span>User:</span>
                        <v-row align="center" no-gutters>
                          <v-avatar :size="35">
                            <v-img
                              :src="
                                $getProp(log, 'logged_by.picture') ||
                                  require(`@/static/images/info/user-default.png`)
                              "
                              alt="CRE avatar"
                            ></v-img>
                          </v-avatar>
                          <v-col class="text-left ml-2 font-weight-bold">
                            <div>
                              {{ $getProp(log, "logged_by.full_name") }}
                            </div>
                          </v-col>
                        </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4">
                  <v-row>
                    <v-col cols="1">
                      <div class="grey-text">
                        <v-icon
                          v-text="$getIcon('mdiAccountCircleOutline')"
                          small
                        ></v-icon>
                      </div>
                    </v-col>
                    <v-col cols="10" class="caption">
                      <div>Contact Person:</div>
                      <div class="pt-1">
                        <v-row align="center" no-gutters>
                          <v-avatar :size="35">
                            <v-img
                              :src="
                                $getProp(
                                  log,
                                  'communicationlog.contacted_with.image'
                                ) ||
                                  require(`@/static/images/info/user-default.png`)
                              "
                              alt="CRE avatar"
                            ></v-img>
                          </v-avatar>
                          <v-col class="text-left ml-2 font-weight-bold">
                            <div>
                              {{
                                $getProp(
                                  log,
                                  "communicationlog.contacted_with.name"
                                ) || "Fix null"
                              }}
                            </div>
                            <div class="caption grey--text">
                              {{
                                $getProp(
                                  log,
                                  "communicationlog.contacted_with.designation.name"
                                )
                              }}
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row v-show="showDetails.includes(i)" no-gutters>
                <div class="grey-text">
                  <v-icon
                    v-text="$getIcon('mdiInformationOutline')"
                    small
                  ></v-icon>
                </div>
                <v-col cols="11" class="caption pl-2">
                  <div>Remarks:</div>
                  <p>{{ log.communicationlog.remarks }}</p>
                </v-col>
              </v-row>
            </v-timeline-item>
          </v-timeline>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getCurrency } from "@/utils/common";
export default {
  name: "LogDetail",
  props: {
    logInfo: {
      type: Object,
      required: true
    },
    communicationLog: {
      type: Boolean,
      default: false
    },
    processLog: {
      type: Boolean,
      default: false
    }
  },
  created() {
    let serviceChainId = this.$getProp(
      this.logInfo,
      "sub_stage_logs.0.sales_achievements.0.service_chain.id"
    );
    if (serviceChainId) {
      this.fetchData(serviceChainId);
    } else {
      this.logs = [this.logInfo];
    }
  },
  data() {
    return {
      dialog: true,
      logs: [],
      showDetails: [0],
      colorMapper: {
        Critical: "red",
        Important: "orange",
        Normal: "green",
        Low: "blue"
      },
      isGeneralLog: !this.logInfo.sub_stage_logs.length
    };
  },
  methods: {
    fetchData(serviceChainId) {
      let params = {
        service_chain: serviceChainId,
        communication: true,
        process: this.processLog
      };
      let url = `/api/v1/crm/logs/`;
      this.$axios.$get(url, { params: params }).then(response => {
        this.logs = response.results;
      });
    },
    getCurrency
  }
};
</script>

<style scoped></style>
